import './App.css';
import { BrowserRouter as Router } from "react-router-dom";
import RouteContainer from "./RouteContainer";
import {ContextProvider} from "./MyContext";
import ToastContainer from "./components/toasts/toast/toast_container";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import React from "react";

function App() {
    return (
        <div className="App">
            <ContextProvider>
                <Router>
                    <RouteContainer/>
                </Router>
                <ToastContainer/>
            </ContextProvider>
        </div>
    );
}

export default App;
